import { FC, ReactNode } from 'react';
import { cn } from '../../utils/cn';

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  description?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  className?: string;
}

export const StatsCard: FC<StatsCardProps> = ({
  title,
  value,
  icon,
  description,
  trend,
  className,
}) => {
  return (
    <div
      data-testid="stat-card"
      className={cn(
        'rounded-xl border border-primary-100/50 dark:border-slate-700 backdrop-blur-sm bg-white/90 dark:bg-slate-800/90 p-6 shadow-sm dark:shadow-slate-900/50',
        className
      )}
    >
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500 dark:text-slate-400">{title}</p>
          <p className="mt-1 text-2xl font-bold text-gray-900 dark:text-slate-100">{value}</p>
          {description && <p className="mt-1 text-sm text-gray-500 dark:text-slate-400">{description}</p>}
          {trend && (
            <div className="mt-2 flex items-center">
              <span
                className={cn(
                  'text-sm font-medium',
                  trend.isPositive ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'
                )}
              >
                {trend.isPositive ? '+' : ''}
                {trend.value}%
              </span>
              <span className="ml-1 text-sm text-gray-500 dark:text-slate-400">vs last month</span>
            </div>
          )}
        </div>
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50/80 dark:bg-primary-900/30">
          <span className="text-primary-600 dark:text-primary-400">{icon}</span>
        </div>
      </div>
    </div>
  );
};
